import FormattedMessage from 'I18n/components/FormattedMessage';
import { CONTENT_ACTION_IDS } from 'content-management-actions-lib/constants/actionIds';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const displayActionSuccessMessage = ({
  isLandingPage,
  actionId
}) => {
  const langKey = isLandingPage ? 'page-details-ui.actions.successes.landingPage' : 'page-details-ui.actions.successes.sitePage';
  FloatingAlertStore.addAlert({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${langKey}.message.${actionId}`
    }),
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${langKey}.title`
    }),
    type: 'success'
  });
};
export const displayActionErrorMessage = ({
  isLandingPage,
  actionId,
  bulkActionErrorDetailsModalButton
}) => {
  const langKey = isLandingPage ? 'page-details-ui.actions.errors.landingPage' : 'page-details-ui.actions.errors.sitePage';
  FloatingAlertStore.addAlert({
    message: /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `${langKey}.message`
      }), bulkActionErrorDetailsModalButton]
    }),
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${langKey}.title.${actionId}`
    }),
    type: 'danger'
  });
};
export const displayCreateLanguageVariationErrorMessage = ({
  isLandingPage,
  error
}) => {
  const errorType = error.responseJSON.errorType || 'DEFAULT_ERROR';
  const langKey = isLandingPage ? 'page-details-ui.actions.errors.landingPage' : 'page-details-ui.actions.errors.sitePage';
  FloatingAlertStore.addAlert({
    message: errorType === 'LANGUAGE_ALREADY_TRANSLATED' ? null : /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${langKey}.message`
    }),
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${langKey}.title.${CONTENT_ACTION_IDS.CREATE_LANGUAGE_VARIANT}.${errorType}`
    }),
    type: 'danger'
  });
};